import { type OverflowModel } from '../../types'
import { type TPaymentsResponse } from '../../../redux/types/PaymentsTypes'

const mapPayments = (payments: TPaymentsResponse[] | undefined): OverflowModel[] | undefined => {
  return payments?.map((item: any) => {
    return {
      id: item.id,
      hash: item.transaction_hash,
      status: item.status,
      transaction_type: item.transaction_type,
      sum: item.amount,
      date: item.create_dt,
    }
  })
}

export default mapPayments
